import { render, staticRenderFns } from "./shanxiSupervisionHome.vue?vue&type=template&id=4c577122"
import script from "./shanxiSupervisionHome.vue?vue&type=script&lang=js"
export * from "./shanxiSupervisionHome.vue?vue&type=script&lang=js"
import style1 from "./shanxiSupervisionHome.vue?vue&type=style&index=1&id=4c577122&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports